import { Component, Mixins, Prop, Watch } from 'vue-property-decorator'
import * as dateutil from '@appbase/util/date-helper'
import { mapGetters } from 'vuex'
import * as types from '@webparts/store/types'
import * as typesAccount from '@account/store/types'

import EventList from './EventList.vue'
import Calendar from './Calendar.vue'
import WebpartTemplate from '@webparts/components/webparts/base/WebpartTemplate.vue'
import WebpartBase from '@webparts/components/webparts/base/WebpartBase'
import { LoadingBar } from '@appbase/components/loading'
import NoData from '@webparts/components/common/NoData.vue'

const getDefaultValue = () => dateutil.uGetDateFormat('yyyy-MM-DD', new Date())

@Component({
    name: 'calendar-webpart',
    components: { Calendar, EventList, WebpartTemplate, LoadingBar, NoData },
    computed: {
        ...mapGetters({
            current: typesAccount.CURRENT,
            commonInfoMounted: types.WEBPART_COMMONDATA_MOUNTED
        }),
    },
})
export default class CalendarWebpart extends Mixins(WebpartBase) {
    @Prop({ type: String, default: getDefaultValue() }) value!: string

    commonInfoMounted!: boolean;

    baseValue: string = ''
    weeks: string[] = [
        this.$t('W_Schedule_Sun').toString(),
        this.$t('W_Schedule_Mon').toString(),
        this.$t('W_Schedule_Tue').toString(),
        this.$t('W_Schedule_Wed').toString(),
        this.$t('W_Schedule_Thu').toString(),
        this.$t('W_Schedule_Fri').toString(),
        this.$t('W_Schedule_Sat').toString(),
    ]

    @Watch('commonInfoMounted')
    onMountedChanged(newVal: boolean) {
        this.loading = !this.commonInfoMounted;
    }

    created() {
        this.baseValue = dateutil.uGetDateFormat(
            'yyyy-MM-DD',
            dateutil.IEDate(this.value))

        this.loading = !this.commonInfoMounted;
    }
}